import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, X } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-[90vh] bg-brand-cream overflow-hidden flex items-center py-12 lg:py-0" data-id="element-48">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-49">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-50">
          {/* Left Column: Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col justify-center" data-id="element-51">
            <div className="inline-flex items-center self-start px-4 py-1.5 rounded-full bg-brand-sage/10 border border-brand-sage/20 mb-6" data-id="element-52">
              <span className="text-brand-sage font-bold text-xs uppercase tracking-wider" data-id="element-53">
                🔬 Protocolo Basado en Ciencia
              </span>
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brand-dark leading-tight mb-6" data-id="element-54">
              No te estás haciendo vieja.{' '}
              <span className="text-brand-terracotta italic" data-id="element-55">
                Solo te falta el manual
              </span>{' '}
              de instrucciones para tus nuevas hormonas.
            </h1>

            <p className="font-sans text-lg md:text-xl text-brand-warm-gray mb-8 leading-relaxed max-w-xl" data-id="element-56">
              Niebla mental, fatiga y vientre hinchado: El protocolo para la
              mujer de +35 que los médicos ignoran.
            </p>

            <div className="space-y-4 mb-10" data-id="element-57">
              {['Te miras al espejo y no te reconoces', "El médico te dice 'es normal a tu edad'", 'Tu dieta de siempre ahora te engorda'].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5 + index * 0.1
            }} className="flex items-center space-x-3" data-id="element-58">
                  <X className="w-5 h-5 text-brand-terracotta flex-shrink-0" data-id="element-59" />
                  <span className="font-sans text-brand-dark font-medium" data-id="element-60">
                    {item}
                  </span>
                </motion.div>)}
            </div>

            {/* Mockup above CTA */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8
          }} className="mb-6" data-id="element-61">
              <img src="https://cdn.magicpatterns.com/uploads/vf1VLCL8i7wKhmcQL8qcg9/sos-2.png" alt="Mujer utilizando el protocolo SOS Premenopausia" className="w-full max-w-sm rounded-2xl shadow-xl border-4 border-white object-cover" data-id="element-62" />
            </motion.div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-brand-terracotta hover:bg-brand-terracotta-dark text-white font-sans font-bold py-4 px-8 rounded-lg shadow-lg shadow-brand-terracotta/20 flex items-center justify-center space-x-2 w-full sm:w-auto transition-colors" onClick={() => document.getElementById('cta-precio')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-63">
              <span data-id="element-64">SÍ, QUIERO RECUPERAR MI ENERGÍA</span>
              <ArrowRight className="w-5 h-5" data-id="element-65" />
            </motion.button>

            <p className="mt-4 text-xs text-brand-warm-gray text-center sm:text-left" data-id="element-66">
              🔒 Acceso inmediato • Garantía de 30 días
            </p>
          </motion.div>

          {/* Right Column: Image — hidden since image moved to left column */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative hidden lg:block" data-id="element-67">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-68">
              <img src="https://cdn.magicpatterns.com/uploads/vf1VLCL8i7wKhmcQL8qcg9/sos-2.png" alt="Mujer utilizando el protocolo SOS Premenopausia" className="w-full h-auto object-cover" data-id="element-69" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-sage/20 rounded-full blur-2xl -z-10" data-id="element-70"></div>
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-brand-terracotta/10 rounded-full blur-2xl -z-10" data-id="element-71"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}